function escapeHtml(input: string) {
  return input
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');
}

export function downloadWordDoc(filename: string, content: string, title?: string) {
  const safe = escapeHtml(content);
  const html = `<!DOCTYPE html><html><head><meta charset="utf-8"><title>${
    escapeHtml(title || filename)
  }</title><style>
    body{font-family: -apple-system,BlinkMacSystemFont,'Segoe UI',sans-serif; color:#111;}
    h1{font-size:18px; margin-bottom:12px}
    pre{white-space:pre-wrap; line-height:1.6; font-family: inherit;}
  </style></head><body>
  ${title ? `<h1>${escapeHtml(title)}</h1>` : ''}
  <pre>${safe}</pre>
  </body></html>`;
  const blob = new Blob(['\ufeff', html], { type: 'application/msword' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename.endsWith('.doc') ? filename : `${filename}.doc`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}

export function printAsPdf(content: string, title?: string) {
  const safe = escapeHtml(content);
  const html = `<!DOCTYPE html><html><head><meta charset="utf-8"><title>${
    escapeHtml(title || 'Export')
  }</title><style>
    @page { margin: 20mm }
    body{font-family: -apple-system,BlinkMacSystemFont,'Segoe UI',sans-serif; color:#111;}
    h1{font-size:18px; margin-bottom:12px}
    pre{white-space:pre-wrap; line-height:1.6; font-family: inherit;}
  </style></head><body>
  ${title ? `<h1>${escapeHtml(title)}</h1>` : ''}
  <pre>${safe}</pre>
  <script>window.onload = function(){ setTimeout(function(){ window.print(); }, 50); }<\/script>
  </body></html>`;
  const win = window.open('', '_blank');
  if (!win) return;
  win.document.open();
  win.document.write(html);
  win.document.close();
}

